import { APPLICATION_STATUS } from "../config/ApplicationConstants";
import { titleCase } from "./format";

export type Optional<T> = T | undefined;

export type Nullable<T> = T | null;

/**
 * @todo: Partial RawDocument
 * This should be filled out...
 */
export interface RawDocument {
  status: (typeof APPLICATION_STATUS)[keyof typeof APPLICATION_STATUS];
  createdAt: number;
  updatedAt: number;
  certificateData?: {
    certificateNumber: string;
    certifiedOn: number;
  };
  formValues?: {
    Q001?: {
      dbaName?: string;
      registeredName: string;
    };
    Q002?: {
      address: string;
    };
    Q100?: {
      ownerName: string;
    }[];
    Q103?: {
      categories: string[];
    };
    Q200: string;
  };
}

export interface NaicsCode {
  code: string;
  description: string;
}

export const getOwnerNames = (doc: RawDocument): string[] =>
  doc?.formValues?.Q100?.map((name) => name.ownerName?.trim()).filter(
    Boolean
  ) ?? [];

export const getNaicsCodes = (doc: RawDocument): NaicsCode[] => {
  const categories = doc?.formValues?.Q103?.categories;
  if (!categories) return [];
  const seen = new Set<string>();
  return categories.reduce<NaicsCode[]>((codes, text) => {
    const [code, description] = text.split("-").map((c) => c.trim());
    if (seen.has(code)) return codes;
    seen.add(code);
    return [...codes, { code, description }];
  }, []);
};

export const getCertificationDate = (doc: RawDocument): Nullable<Date> => {
  const epoch = doc?.certificateData?.certifiedOn;
  if (!epoch) return null;
  return new Date(epoch);
};

export const getCertificationExpirationDate = (
  doc: RawDocument
): Nullable<Date> => {
  const epoch = doc?.certificateData?.certifiedOn;
  if (!epoch) return null;
  const date = new Date(epoch);
  date.setFullYear(date.getFullYear() + 2);
  return date;
};

export const getRegisteredBusinessName = (doc: RawDocument): string =>
  titleCase(doc?.formValues?.Q001?.registeredName);

export const getDbaBusinessName = (doc: RawDocument): string =>
  titleCase(doc?.formValues?.Q001?.dbaName);
